;$(function() {
    function isMobile() {
        return window.matchMedia("(max-width: 767px)").matches;
    }

    function getRem() {
        if (window.matchMedia("(max-width: 767px)").matches) {
            return $(window).width() * 0.0138888
        }
        if (window.matchMedia("(max-width: 1460px)").matches) {
            return $(window).width() * 0.006849315
        }
        return Number($(':root').css('font-size').replaceAll(/px/g, ''));
    }

    var rem = getRem();

    function cRem(num) {
        return num * rem;
    }

    var keys = {37: 1, 38: 1, 39: 1, 40: 1, 32: 1, 33: 1, 34: 1, 35: 1, 36: 1};

    function preventDefault(e) {
        if (e.cancelable) {
            e.preventDefault();
        }
    }

    function preventDefaultForScrollKeys(e) {
        if (keys[e.keyCode]) {
            preventDefault(e);
            return false;
        }
    }

    var supportsPassive = false;
    try {
        window.addEventListener("test", null, Object.defineProperty({}, 'passive', {
            get: function () { supportsPassive = true; } 
        }));
    } catch(e) {}

    var wheelOpt = supportsPassive ? { passive: false } : false;
    var wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

    function disableScroll() {
        window.addEventListener('DOMMouseScroll', preventDefault, false); // older FF
        window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
        window.addEventListener('touchmove', preventDefault, wheelOpt); // mobile
        window.addEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    function enableScroll() {
        window.removeEventListener('DOMMouseScroll', preventDefault, false); // older FF
        window.removeEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
        window.removeEventListener('touchmove', preventDefault, wheelOpt); // mobile
        window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
    }

    // <<<<< BTOCSITE-20537 [렛츠그램] 브랜드필로소피 ui 수정
    /**
     * 비디오 준비 함수
     */
    function initVideo() {
        var video =  document.querySelectorAll('video');
        var fileUrls = [];

        if (video !== undefined) {
            video.forEach(function(element) {
                fileUrls.push(whichSizeVideo(element));
            });

            // pre-cache
            if (window.caches) {
                window.caches.open('video-pre-cache').then(function (cache) {
                    Promise.all(fileUrls.map(function (fileUrl) {
                        fetchAndCache(fileUrl, cache)
                    })); 
                });
            }
        }
    }

    /**
     * video > source 추가 함수
     * @param {element} element video element
     * @param {string} src video src
     */
    function addSourceToVideo(element, src) {
        removeSourceToVideo(element);

        var source = document.createElement('source');
        source.src = src;
        source.type = 'video/mp4';
        element.appendChild(source);
    }

    /**
     * video > source 제거 함수
     * @param {element} element video element
     */
    function removeSourceToVideo(element) {
        Array.from(element.children).forEach(function (child) {
            element.removeChild(child);
        })
    }

    /**
     * video device 크기에 다른 src 선택 함수
     * @param {element} element video element
     * @returns video src
     */
    function whichSizeVideo(element) {
        var src = !isMobile() ? element.dataset.pcVod : element.dataset.moVod;
        var pst = !isMobile() ? element.dataset.posterPc : element.dataset.posterMo;

        addSourceToVideo(element, src);

        return src
    }

    /**
     * 비디오 시퀀스 초기화
     * @param {string} value 재생 종류
     */
    function updateVideo(value) {
        var cls = value === undefined ? '' : value;

        var scenes = document.querySelectorAll('.visual-sequence.video > .visual-scene');
        scenes.forEach(function (scene) {
            var video = scene.querySelector('video');

            if (!video) return;

            if (video.readyState !== 4) {
                // 로드 전 이면 선행 로드
                // console.log('!!!!! load', scene.classList[1]);
                video.load();
            } else {
                video.pause();
                video.currentTime = 0;

                if (scene.classList.contains(cls)) {
                    scene.style.display = 'block';

                    // 플레이전 버튼 상태 초기화
                    var $btnA = $videoBtnA.filter('.play-' + cls);
                    deactivateVideoBtn($btnA);

                    video.play();

                    // console.log('!!!!! paly', scene.classList[1]);
                    
                    // 재생 중인 고유 시퀀스 class 저장
                    current = cls;
                } else {
                    // 로드 후 라면 현재 비디오 제외하고 숨김
                    if (!scene.classList.contains(current)) {
                        scene.style.display = 'none';
                        // console.log('!!!!! pause', scene.classList[1]);
                    }
                }
            }
        })
    }

    /**
     * 비디오 재생 진행 상태 변경 함수
     * @param {string} cls 시퀀스 고유 css 클래스
     * @param {object} params 비디오 정보
     */
    function progressVideoBtn(cls, params) {
        var $btnA = $videoBtnA.filter('.play-' + cls);
        var $bar = $btnA.prev().find('.bar');
        
        var offset = params.offset;
        var percent = params.percent;
        var ended = params.ended;

        changeSiblingsVideoBtn(cls);

        $bar.css({
            strokeDashoffset: offset,
            transition: 'stroke-dashoffset .25s linear'
        })
        
        if ($bar.is(':hidden')) {
            $bar.show();
        }
        
        // 자동 재생
        if (autoplay && ended) {
            var $nextLI = $btnA.closest('li').next();
            if ($nextLI.length) {
                var nextBtnA = $nextLI.find('a[class^="play-"]');

                nextBtnA.trigger('click'); // click handler 안에 autoplay = false 있으므로 
                autoplay = true; // 다시 true
            }
        }
    }

    /**
     * 비디오 재생 버튼 활성화 고정 함수
     * @param {string} cls 시퀀스 고유 css 클래스
     */
    function changeSiblingsVideoBtn(cls) {
        var $btnA = $videoBtnA.filter('.play-' + cls);
        var $li = $btnA.closest('li');

        $li.prevAll().find('a[class^="play-"]').each(function () {
            // activateVideoBtn($(this)); // 이전 재생 진행도 유지 
            deactivateVideoBtn($(this)); // 이전 재생 진행도 유지 안함
        });

        $li.nextAll().find('a[class^="play-"]').each(function () {
            deactivateVideoBtn($(this));
        });
    }

    function activateVideoBtn($btnA) {
        var $bar = $btnA.prev().find('.bar');

        $bar.css('transition', 'none').show();
        $btnA.prev().addClass('active');
    }

    function deactivateVideoBtn($btnA) {
        var $bar = $btnA.prev().find('.bar');

        $bar.css('transition', 'none').hide();
        $btnA.prev().removeClass('active');
    }

    /**
     * 디스크리머 체크 함수
     * @param {string} cls 시퀀스 고유 css 클래스
     * @param {number} currentTimer 영상 재생 중 시간
     */
    function checkerDisclaimer(cls, currentTimer) {
        var $section = $('.visual-sequence.video');
        var $scene = $section.find('> .visual-scene');

        // 현재 비디오
        var $disclaimer = $scene.filter('.' + cls).find('.scene-disclaimer'); 

        $disclaimer.each(function () {
            var showingStartTimer = parseFloat($(this).data('showing-start-timer'));
            var showingEndTimer = parseFloat($(this).data('showing-end-timer'));

            // dataset 통해 노출 여부 지정
            if (!isNaN(showingStartTimer) && !isNaN(showingEndTimer)) {
                if (currentTimer > showingStartTimer && currentTimer < showingEndTimer) {
                    $(this).fadeIn();
                } else {
                    $(this).fadeOut();
                }
            }
        })
    }

    /**
     * scrollTrigger 스냅
     */
     function stSnap() {
        ScrollTrigger.create({
            trigger: '.visual-sequence.video',
            start: 'top bottom',
            end: 'top',
            snap: {
                snapTo: 1, 
                duration: {min: 0.2, max: 0.2},
                delay: 0,
                ease: 'none'
            },
            onLeaveBack: function() {
                // console.log('xxxxx out up');

                // 정지
                updateVideo();
                toggleVideoBtn();
            },
            onLeave: function () {
                // console.log('xxxxx in down');
                
                // 재생
                // 재생중인 비디오 유지, 없으면 첫번째 영상으로 시작
                updateVideo(current ? current : 'minus');
                toggleVideoBtn(true);
            }
        })

        ScrollTrigger.create({
            trigger: '.visual-wrap',
            start: 'bottom bottom',
            end: 'bottom',
            snap: {
                snapTo: 1, 
                duration: {min: 0.2, max: 0.2},
                delay: 0,
                ease: 'none'
            },
            onLeave: function() {
                // console.log('xxxxx out down');

                // 정지
                updateVideo();
                toggleVideoBtn();
            },
            onLeaveBack: function() {
                // console.log('xxxxx in up');

                updateVideo(current);
                toggleVideoBtn(true);
            },
            onSnapComplete: function (value) {
                // 방향 위로 올리는 snap 인 경우
                if (value.progress === 0) {
                    var $sec = $('.visual-sequence.start');
                    var st = $sec.offset().top + $sec.outerHeight();

                    scrollTo(st + 1, 200);
                }
            }
        })
    }

    /**
     * 비디오형 scrolltrigger
     */
    function stVideo() {
        var $section = $('.visual-sequence.video');
        var $scene = $section.find('> .visual-scene');
        var sequenceHeight = $section.outerHeight();

        $scene.each(function (idx) {
            var video = $(this).find('video').get(0);
        
            function handleEvent(event) {
                var elm = $(event.target).closest('.visual-scene').get(0);
                if (!elm) return;

                var cls = elm.classList[1];
                var video = event.target;


                if (event.type === 'play') {
                    // 현재 비디오 아닌 디스크리머 숨김
                    $scene.not('.' + cls).find('.scene-disclaimer').hide();
                }

                if (event.type === 'canplaythrough') {
                    // 첫장면 정지 대기
                    video.removeEventListener('canplaythrough', handleEvent);
                    video.pause();

                    // 첫번째 영상 준비되면 로딩바 제거 위함
                    if (cls === 'minus') {
                        $loadingDIV.hide(); 
                    }
                } else if (event.type === 'timeupdate') {
                    var ct = video.currentTime;
                    var tl = video.duration;
                    var cls = video.parentElement.classList[1];
                    var per = getLinearFunction(0, tl, 0, 1, ct);
                    var offset = getLinearFunction(0, tl, 346, 600, ct);

                    if (!isNaN(offset) && current === cls) {
                        progressVideoBtn(cls, {
                            offset: parseFloat(offset.toFixed(0)),
                            percent: per,
                            ended: ct === tl
                        });

                        checkerDisclaimer(cls, ct);
                    }
                }
            }

            if (video) {
                video.addEventListener('play', handleEvent);
                video.addEventListener('timeupdate', handleEvent);
                video.addEventListener('canplaythrough', handleEvent);
            }
        })
       
        gsap.timeline({
            scrollTrigger: {
                trigger: '.visual-sequence.video',
                pin: true,
                pinSpacing: true,
                start: 'top top',
                end: '100%',
                invalidateOnRefresh: false
            }
        });
    };

    /**
     * 버튼 등장 모션
     * @param {boolean} showing 노출 유무
     */
    function toggleVideoBtn(showing) {
        if (!!showing) {
            gsap.to('.visual-navi li', {alpha: 1, xPercent:0, yPercent:0, duration: 0.6, stagger: 0.13});
        } else {
            gsap.killTweensOf('.visual-navi li');
            gsap.set('.visual-navi li', (isMobile() ? {alpha: 0, yPercent:-50} : {alpha: 0, xPercent:-50}));
        }
    }

    /**
     * gasp timeline 옵션 반환
     * @param {string} cls 시퀀스 고유 css 클래스
     * @returns gsap timeline 옵션
     */
    function getTimelineOption(cls) {
        var $section = $('.visual-sequence.' + cls);
        var sequenceHeight = $section.outerHeight();
        var timelineOption;

        switch(cls) {
            case 'start' :
                timelineOption = {
                    scrollTrigger: {
                        id: 'start',
                        trigger: $section,
                        pin: true,
                        pinSpacing: true,
                        start: 'top top',
                        end: '+=200%',
                        scrub: true,
                        toggleActions: 'restart none restart reset',
                        invalidateOnRefresh: false,
                        onEnter: function(self) {
                            // 선 로드
                            updateVideo();
                        }
                    },
                    defaults: {
                        ease: 'none',
                        duration: 0.3,
                    },
                }

                break;
            default :
        }

        return timelineOption;
    }

    /**
     * 스크롤 이동 함수
     * @param {number} top 위치
     * @param {number} duration 속도
     */
     function scrollTo(top, duration) {
        var speed = duration === undefined ? 300 : duration;

        disableScroll();

        $('html, body').stop(true, true);
        $('html, body').animate({
            scrollTop: top,
        }, speed, function() {
            enableScroll();
        });
    }

    /**
     * 1차 방적식 함수
     */
    function getLinearFunction(a, b, c, d, x) {
        return (d - c) / (b - a) * (x - a) + c
    }

    /**
     * 화면 크기 (모바일 브라우저 주소창 감안한 크기) 지정
     */
    function setInnerHeight() {
        $visualDIV.attr('style', '--vh:' + (window.innerHeight) * 0.01);
    }

    function setProperty() {
        $visualDIV = $('.visual-wrap');
        $startBtn = $('.btn-start');
        $videoBtnA = $('.visual-navi li > a');
        $loadingDIV = $('.loading-video');
    }

    function bind() {
        $startBtn.on('click', function (e) {
            e.preventDefault();

            // 플레이 버튼으로 조작 할 때는 첫번째 영상 부터 나오도록
            autoplay = true;
            current = 'minus';

            scrollTo($('.visual-sequence.video').offset().top);
        });

        $videoBtnA.on('click', function (e) {
            e.preventDefault();

            autoplay = false;

            var target = $(e.currentTarget);
            var cls = target.attr('class').replace(/.+\-/i, '');

            updateVideo(cls);
        });
    }
    
    var current = '';       // 시퀀스 고유 클래스 [ minus | plus | division | multiple ]
    var autoplay = true;    // 자동재생 유무
    var $visualDIV;         // 비주얼 컨테이너
    var $startBtn;          // 시작버튼
    var $videoBtnA;         // 재생버튼
    var $loadingDIV;        // 영상 로딩바

    // >>>>> BTOCSITE-20537 [렛츠그램] 브랜드필로소피 ui 수정

    vcui.require(['libs/gsap-3.10.4.min', 'libs/ScrollTrigger-3.10.4.min', 'libs/lodash-1.8.3.min'], function () {
        setProperty();
        bind();
        setInnerHeight();

        var windowWidth = $(window).width();
        $(window).on('resize', _.debounce(function() {
            if (windowWidth !== $(window).width()) {
                rem = getRem();
                ScrollTrigger.refresh();
                windowWidth = $(window).width();
            }

            setInnerHeight();
        }, 300));

        $(window).on('load orientationchange', function() {
            ScrollTrigger.refresh();
        });

        var progress = 0;
        ScrollTrigger.addEventListener("refreshInit", function() {
            progress = document.documentElement.scrollTop / ScrollTrigger.maxScroll(window);
        });
        ScrollTrigger.addEventListener("refresh", function() {
            document.documentElement.scrollTop = progress * ScrollTrigger.maxScroll(window);
        });
        
        gsap.registerPlugin(ScrollTrigger);

        ScrollTrigger.matchMedia({
            // 모바일
            "(max-width: 767px)": function() {
                var gramVisual = {
                    start: function() {
                        var $section = $('.visual-sequence.start');
                        var q = gsap.utils.selector($section[0]);

                        var tl = gsap.timeline(getTimelineOption('start'));
                        tl.set(q('.visual-scene:not(.scene1, .scene2)'), { autoAlpha: 0, })
                            // .addLabel('setSequnce')
                            .set(q('.scene1'), { autoAlpha: 1, })
                            // .addLabel('setScene1')
                            .set(q('.scene2'), { autoAlpha: 1, })
                            .set(q('.scene2 .scene-text .shot1 .cut1'), { scale: 3, yPercent: 100, backgroundImage: 'linear-gradient(45deg, #c968f7, #5c4cfb)', backgroundSize: '100% 100%', webkitTextFillColor: 'transparent', webkitBackgroundClip: 'text', })
                            .set(q('.scene2 .scene-text .shot1 .cut2'), { scale: 10, autoAlpha: 0, yPercent: -200, })
                            .set(q('.scene2 .scene-text .shot1 .cut3'), { scale: 10, autoAlpha: 0, yPercent: -200, })
                            // .addLabel('setScene2')
                            .to(q('.scene1'), { autoAlpha: 0, duration: 0.05, })
                            // .addLabel('playScene1')
                            .to(q('.scene2 .scene-text .shot1 .cut1'), { scale: 1, yPercent: 0, ease: 'power2.in', })
                            .to(q('.scene2 .scene-text .shot1 .cut1'), { backgroundImage: 'linear-gradient(45deg, #fff, #fff)', ease: 'power2.in', duration: 0.2, }, '>-0.2')
                            .to(q('.scene2 .scene-text .shot1 .cut2'), { autoAlpha: 1, ease: 'power2.in', }, '>+0.1')
                            .to(q('.scene2 .scene-text .shot1 .cut2'), { scale: 1, yPercent: 0, ease: 'power2.in', }, '<')
                            .to(q('.scene2 .scene-text .shot1 .cut3'), { autoAlpha: 1, ease: 'power2.in', }, '>+0.1')
                            .to(q('.scene2 .scene-text .shot1 .cut3'), { scale: 1, yPercent: 0, ease: 'power2.in', }, '<')
                            // .addLabel('playScene2')
                            .set(q('.cover'), { zIndex: 1, })
                            // .addLabel('setCover')
                            .to(q('.cover'), { autoAlpha: 1, duration: 0.2, ease: 'power2.in', }, '>+0.6')
                            .set(q('.scene2'), { autoAlpha: 0, })
                            // .addLabel('playCover')
                            .set({}, {}, '>+0.5')
                    },
                    init: function() {
                        initVideo();
                        this.start();
                        stVideo();
                        stSnap();
                        toggleVideoBtn();
                    }
                }
                gramVisual.init();
            },
            "(min-width: 768px)": function() {
                var gramVisual = {
                    start: function() {
                        var $section = $('.visual-sequence.start');
                        var q = gsap.utils.selector($section[0]);

                        var tl = gsap.timeline(getTimelineOption('start'));
                        tl.set(q('.visual-scene:not(.scene1, .scene2)'), { autoAlpha: 0, })
                            // .addLabel('setSequnce')
                            .set(q('.scene1'), { autoAlpha: 1, })
                            // .addLabel('setScene1')
                            .set(q('.scene2'), { autoAlpha: 1, })
                            .set(q('.scene2 .scene-text .shot1 .cut1'), { scale: 3, yPercent: 100, backgroundImage: 'linear-gradient(45deg, #c968f7, #5c4cfb)', backgroundSize: '100% 100%', webkitTextFillColor: 'transparent', webkitBackgroundClip: 'text', })
                            .set(q('.scene2 .scene-text .shot1 .cut2'), { scale: 10, autoAlpha: 0, yPercent: -200, })
                            .set(q('.scene2 .scene-text .shot1 .cut3'), { scale: 10, autoAlpha: 0, yPercent: -200, })
                            // .addLabel('setScene2')
                            .to(q('.scene1'), { autoAlpha: 0, duration: 0.05, })
                            // .addLabel('playScene1')
                            .to(q('.scene2 .scene-text .shot1 .cut1'), { scale: 1, yPercent: 0, ease: 'power2.in', })
                            .to(q('.scene2 .scene-text .shot1 .cut1'), { backgroundImage: 'linear-gradient(45deg, #fff, #fff)', ease: 'power2.in', duration: 0.2 }, '>-0.2')
                            .to(q('.scene2 .scene-text .shot1 .cut2'), { autoAlpha: 1, ease: 'power2.in', }, '>+0.1')
                            .to(q('.scene2 .scene-text .shot1 .cut2'), { scale: 1, yPercent: 0, ease: 'power2.in', }, '<')
                            .to(q('.scene2 .scene-text .shot1 .cut3'), { autoAlpha: 1, ease: 'power2.in', }, '>+0.1')
                            .to(q('.scene2 .scene-text .shot1 .cut3'), { scale: 1, yPercent: 0, ease: 'power2.in', }, '<')
                            // .addLabel('playScene2')
                            .set(q('.cover'), { zIndex: 1, })
                            // .addLabel('setCover')
                            .to(q('.cover'), { autoAlpha: 1, ease: 'power2.in', }, '>+0.6')
                                // .set(q('.scene8'), { autoAlpha: 0, })
                                // .set(q('.scene4'), { autoAlpha: 0, })
                            .set(q('.scene2'), { autoAlpha: 0, })
                            // .addLabel('playCover')
                            .set({}, {}, '>+0.5')
                    },
                    init: function() {
                        initVideo();
                        this.start();
                        stVideo();
                        stSnap();
                        toggleVideoBtn();
                    }
                }
                gramVisual.init();
            }
        });
    });
});
$(document).on('ready',function(){
    //BTOCSITE-26928
    $('html').addClass('gram-brandStory');    

    $('.banner-area .link-banner.link2').on('click',function(e){
        if (isApp()) {
            e.preventDefault();
            var url = $('.banner-area .link-banner.link2').attr('href');
            if (vcui.detect.isIOS) {
              var jsonString = JSON.stringify({
                command: "openLinkOut",
                url: url,
              });
              webkit.messageHandlers.callbackHandler.postMessage(jsonString);
            } else if (vcui.detect.isAndroid) {
              android.openLinkOut(url);
            }
        }
    });
});

function fetchAndCache(videoFileUrl, cache) {
  // Check first if video is in the cache.
  return cache.match(videoFileUrl).then(function (cacheResponse) {
    //console.log(cacheResponse);

    // Let's return cached response if video is already in the cache.
    if (cacheResponse) return cacheResponse;
      
    // Otherwise, fetch the video from the network.
    return fetch(videoFileUrl).then(function (networkResponse) {
      // Add the response to the cache and return network response in parallel.
      cache.put(videoFileUrl, networkResponse.clone());
      
      return networkResponse;
    });
  });
}

/* var mediaSource = new MediaSource();
video.src = URL.createObjectURL(mediaSource);
mediaSource.addEventListener('sourceopen', sourceOpen, { once: true });

function sourceOpen() {
    URL.revokeObjectURL(video.src);
    var sourceBuffer = mediaSource.addSourceBuffer('video/mp4; codecs="avc1.42E01E, mp4a.40.2"');

    // If video is preloaded already, fetch will return immediately a response
    // from the browser cache (memory cache). Otherwise, it will perform a
    // regular network fetch.
    fetch('/lg5-common/images/GRC/intro/vod/minus_pc.mp4')
    .then(function (response) {
        response.arrayBuffer() 
    })
    .then(function (data) {
        // Append the data into the new sourceBuffer.
        sourceBuffer.appendBuffer(data);
        // TODO: Fetch file_2.webm when user starts playing video.
    })
    .catch(function (error) {
        // TODO: Show "Video is not available" message to user.
    });
} */